export default __webpack_public_path__ + "static/media/09.b6c7b3a5.jpg";